import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-application-details-risk',
    templateUrl: './application-details-risk.component.html',
    styleUrls: ['./application-details-risk.component.css']
})
export class ApplicationDetailsRiskComponent implements OnInit {
    @Input() risk: any = {};

    public open: boolean = false;

    constructor() {
    }

    ngOnInit(): void { }

}
